import { ApiClient } from '@k2/common/backend/api-client';

export class CostSavingEndpoint {
  constructor(private api: ApiClient) {

  }

  getFormCreateCostSaving = (assignmentServiceInstanceId: number) => {
    return this.api.get(`/assignment-service-instance/${assignmentServiceInstanceId}/cost-saving/form-create`);
  };

  createCostSaving = (assignmentServiceInstanceId: number, data: any) => {
    return this.api.post(`/assignment-service-instance/${assignmentServiceInstanceId}/cost-saving`, data);
  }

  getFormUpdateCostSaving = (costSavingId: number) => {
    return this.api.get(`/cost-saving/${costSavingId}/form-update`);
  };

  updateCostSaving = (costSavingId: number, data: any) => {
    return this.api.patch(`/cost-saving/${costSavingId}`, data);
  }

  deleteCostSaving = (costSavingId: number) => {
    return this.api.delete(`/cost-saving/${costSavingId}`);
  };
}
